<template>
  <ul class="list-group list-group-flush">
    <li v-for="(item, index) in languages" :key="index" class="list-group-item list-group-item-action" style="cursor: pointer" @click="changeLanguage(item.code)" data-bs-dismiss="modal">
      {{ item.label }} ({{ item.code.toUpperCase() }})
    </li>
  </ul>
</template>

<script>
export default {
  name: "Languages",
  data() {
    return {
      languages: [
          { 'code': 'us', 'label': 'English' },
          { 'code': 'uk', 'label': 'English' },
          { 'code': 'fr', 'label': 'French' },
          { 'code': 'es', 'label': 'Spanish' },
          { 'code': 'es-ar', 'label': 'Spanish (Argentina)' },
          { 'code': 'it', 'label': 'Italian' },
          // { 'code': 'ru', 'label': 'Russian' },
          { 'code': 'el', 'label': 'Greek' },
          { 'code': 'ko', 'label': 'Korean' },
          { 'code': 'de', 'label': 'German' },
          { 'code': 'pt', 'label': 'Portuguese' },
          { 'code': 'tr', 'label': 'Turkish' },
          { 'code': 'ar', 'label': 'Arabic' },
          { 'code': 'he', 'label': 'Hebrew' },
          { 'code': 'ja', 'label': 'Japanese' },
          { 'code': 'idn', 'label': 'Indonesian' },
          { 'code': 'sv', 'label': 'Swedish' }
      ]
    }
  },
  methods: {
    changeLanguage(code) {
      localStorage.setItem('language', code);
      location.href = '/setLocale/' + code;
      // this.$emit('changeLanguage', code);
    }
  }
}
</script>

<style scoped>

</style>
